import TelaCarregamento from "./TelaCarregamento";

const CarregamentoComponentes = {
    TelaCarregamento
}

export default CarregamentoComponentes;